// Package
// import * as sdk from '@nuinalp/global-website-sdk-js/browser';

// Service
import Service from '@/services';

// Types
import type { NuxtApp } from '#app';

const serviceInstance = (nuxtApp: NuxtApp) => {
  // sdk.agent.setUrl(nuxtApp.$config.NNP_BACKEND_API_URL);
  // sdk.agent.setToken(nuxtApp.$config.NNP_BACKEND_API_KEY);

  // const services = new Service(sdk, nuxtApp as NuxtApp);

  return {};
}

export default defineNuxtPlugin((nuxtApp) => {
  return {
      provide: {
        services: serviceInstance(nuxtApp as NuxtApp),
      }
  }
})

